/* Uses the existing theme product-form component for submission and cart updates. */
if (!customElements.get('recipe-product-row')) {
  customElements.define('recipe-product-row', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-recipe-variant-select]')) return;
        this.updateVariant(event.target);
      });
    }

    updateVariant(select) {
      const option = select.selectedOptions[0];
      if (!option) return;
      const price = this.querySelector('[data-recipe-price]');
      const template = Array.from(this.querySelectorAll('template[data-recipe-variant]'))
        .find((item) => item.dataset.recipeVariant === option.value);
      if (price && template) price.replaceChildren(template.content.cloneNode(true));

      // The select itself is named "id", so FormData submits the chosen variant.
      const button = this.querySelector('button[type="submit"]');
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.querySelector('span').textContent = available ? 'Hinzufügen' : 'Ausverkauft';

      const productForm = this.querySelector('product-form');
      if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
    }
  });
}